import { render, staticRenderFns } from "./SillyApiKeysPage.vue?vue&type=template&id=a387389a"
import script from "./SillyApiKeysPage.vue?vue&type=script&lang=js"
export * from "./SillyApiKeysPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports